import {
  Component,
  HostBinding,
  ViewEncapsulation
} from '@angular/core';
import {
  PaginationModel,
} from '@spartacus/core';
import {
  ItemService,
  ListComponent,
  ListService
} from '@spartacus/organization/administration/components';
import { TableStructure } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { UigOrganizationTableType } from '../../uig-organization.model';

@Component({
    selector: 'app-uig-user-list',
    templateUrl: './uig-user-list.component.html',
    styleUrls: ['./uig-user-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigUserListComponent<T = any, P = PaginationModel> extends ListComponent<T, P> {

  readonly uigStructure$: Observable<TableStructure> = this.service.getStructure();

  constructor(
    protected service: ListService<T, P>,
    protected organizationItemService: ItemService<T>,
  ) {
    super(service, organizationItemService)
  };

  @HostBinding('class')
  uigViewType: UigOrganizationTableType = UigOrganizationTableType.UIG_USER;
}
